import { Dropdown } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../Components/Button"
import Icon from "../../../../Icon"

import styles from "./RowActionMenu.module.less"

/**
 * The row Action menu: exactly three items, in a fixed order.
 *
 * Delete icon is rendered disabled rather than hidden when the row has no icon, so the menu keeps a
 * stable shape and support does not have to re-read it every time. Opening the menu closes anything
 * else the row has open — that is the page's job, done through onOpen.
 */
const RowActionMenu = ({ record, onOpen, onViewHistory, onAddIcon, onDeleteIcon }) => {
  const { t } = useTranslation()

  const items = [
    // Never disabled, including on a row that has never been edited: the log answers with its own
    // empty state rather than the menu hiding the way in.
    { key: "history", label: t("View history"), icon: <Icon type="clock" /> },
    {
      key: "add-icon",
      label: record.icon_url ? t("Replace icon") : t("Add icon"),
      icon: <Icon type="arrow_out_of_box" />
    },
    {
      key: "delete-icon",
      label: t("Delete icon"),
      icon: <Icon type="delete" />,
      // danger on the item itself, not a <Text type="danger"> inside it: an inner colour would win
      // over the disabled state and the item would keep looking clickable on a row with no icon.
      danger: true,
      disabled: !record.icon_url
    }
  ]

  const handleClick = ({ key }) => {
    if (key === "history") onViewHistory(record)
    if (key === "add-icon") onAddIcon(record)
    if (key === "delete-icon") onDeleteIcon(record)
  }

  return (
    <Dropdown
      menu={{ items, onClick: handleClick, className: styles.menu }}
      trigger={["click"]}
      placement="bottomRight"
      onOpenChange={(open) => open && onOpen(record)}
    >
      <ButtonComponent
        type="text"
        size="small"
        icon={<Icon type="three_dots" />}
        data-testid="payment-matching-row-actions"
      />
    </Dropdown>
  )
}

export default RowActionMenu
